<div class="inner-container ion-text-center">
  <div class="centered-content">
    <span class="no-data">
      <ion-text large class="no-data">
        <ion-icon [name]="serverError ? 'information-circle' : 'cloud-offline'"></ion-icon>
        <br><br>
        <strong>
          {{ 'http-error.Información'  | translate }}
        </strong>
        <!-- {{ errorMsg }} -->
        <br>
        <ion-text small color="medium">
          {{ serverError ? serverError.message : ('http-error.Compruebe su conexión a Internet y vuelva a intentarlo' | translate) }}
        </ion-text>
      </ion-text>
      <br><br>
      <ion-text class="ion-text-center" color="primary" (click)="retry.emit()">
        {{ 'http-error.Reintentar'  | translate }}
      </ion-text>
    </span>
  </div>
</div>